import { useEffect, useState } from "react";
import { supabase } from "../../supabase-client";

export default function Contacto() {
   // eslint-disable-next-line 
   const [change, setChange] = useState(false);
   // eslint-disable-next-line
   const [tasks, setTasks] = useState([]);
   const [administradores, setAdministradores] = useState([]);
   const [form, setForm] = useState({
      nombre: "",
      email: "",
      consulta: "",
   });
   const [enviando, setEnviando] = useState(false);
   const [mensaje, setMensaje] = useState("");
   const [tipoMensaje, setTipoMensaje] = useState(""); // success or error

   const fetchAdmin = async () => {
      const { error, data } = await supabase
         .from("admin_users")
         .select(
            `
            id,
            usuario,
            email,
            password_hash,
            recibemails
            `
         )
         .eq("recibemails", "S")
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading usuario: ", error.message);
         return;
      }

      setAdministradores(data);
   };

   const fetchTabla = async () => {
      const { error, data } = await supabase
         .from("tabla")
         .select("*")
         .eq("cod", 5)
         .gt("orden", 1)
         .order("created_at", { ascending: true });

      if (error) {
         console.error("Error reading task: ", error.message);
         return;
      }

      setTasks(data);
   };

   useEffect(() => {
      fetchAdmin();
      fetchTabla();
   }, [change]);

   const handleChange = (e) => {
      setForm({ ...form, [e.target.name]: e.target.value });
   };

   // 👈 Extract email sending logic to separate function
   const sendEmailToAdmin = async (admin, formData) => {
      console.log(`Sending email to: ${admin.email}`);

      try {
         const response = await fetch(
            "https://coympvieahjboblypoft.supabase.co/functions/v1/send-mail",
            {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
               },
               body: JSON.stringify({
                  aquien: admin.email,
                  subject: `Nueva consulta de ${formData.nombre}`,
                  email: formData.email,
                  message: `
                     <h2>Nueva Consulta Recibida</h2>
                     <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
                        <div style="background-color: #f8f9fa; padding: 15px; border-radius: 5px; margin-bottom: 20px;">
                           <h3 style="color: #333; margin: 0;">Detalles del Contacto:</h3>
                        </div>
                        
                        <div style="margin-bottom: 15px;">
                           <strong>Nombre:</strong> ${formData.nombre}
                        </div>
                        
                        <div style="margin-bottom: 15px;">
                           <strong>Email:</strong> <a href="mailto:${formData.email}">${formData.email}</a>
                        </div>
                        
                        <div style="margin-bottom: 20px;">
                           <strong>Fecha:</strong> ${new Date().toLocaleString("es-AR")}
                        </div>
                        
                        <div style="background-color: #f1f3f4; padding: 15px; border-radius: 5px;">
                           <strong>Consulta:</strong>
                           <p style="margin: 10px 0 0 0; line-height: 1.5;">${formData.consulta}</p>
                        </div>
                        
                        <div style="margin-top: 20px; padding: 15px; background-color: #e8f5e8; border-radius: 5px;">
                           <p style="margin: 0; font-size: 14px; color: #666;">
                              <strong>Nota:</strong> Este email fue enviado desde el formulario de contacto de Diego Curutchet.
                              Para responder, utiliza el email: <a href="mailto:${formData.email}">${formData.email}</a>
                           </p>
                        </div>
                     </div>
                  `,
               }),
            }
         );

         const result = await response.json();
         
         if (result.error) {
            console.error(`Error sending email to ${admin.email}:`, result.error);
            return {
               success: false,
               email: admin.email,
               error: result.error,
            };
         } else {
            console.log(`✅ Email sent successfully to: ${admin.email}`);
            return { success: true, email: admin.email };
         }
      } catch (error) {
         console.error(`Failed to send email to ${admin.email}:`, error);
         return {
            success: false,
            email: admin.email,
            error: error.message,
         };
      }
   };
   
   const handleSubmit = async (e) => {
      e.preventDefault();
      setEnviando(true);
      setMensaje("");
      setTipoMensaje("");

      try {
         // Save to database first
         const { error: dbError } = await supabase
            .from("contacto")
            .insert([
               {
                  nombre: form.nombre,
                  email: form.email,
                  consulta: form.consulta,
                  response: false,
               },
            ])
            .select()
            .single();

         if (dbError) throw dbError;

         // 👈 Send emails to all admins using map instead of loop
         const emailPromises = administradores
            .filter(admin => admin.recibemails === "S" && admin.email)
            .map(admin => sendEmailToAdmin(admin, form));

         // Wait for all emails to be sent
         const emailResults = await Promise.all(emailPromises);

         // 👈 Count results after all promises resolve
         const emailsSent = emailResults.filter(r => r.success).length;
         const emailErrors = emailResults.filter(r => !r.success).length;

         console.log(`📊 Email Results: ${emailsSent} sent, ${emailErrors} failed`);
         console.log("Detailed results:", emailResults);

         // Show appropriate success message
         if (emailsSent > 0) {
            if (emailErrors === 0) {
               setMensaje(
                  `¡Mensaje enviado correctamente! Te contactaremos pronto.`
               );
            } else {
               setMensaje(
                  `¡Mensaje guardado! Enviado a ${emailsSent} administrador${
                     emailsSent > 1 ? "es" : ""
                  }, ${emailErrors} falló${
                     emailErrors > 1 ? "n" : ""
                  }. Te contactaremos pronto.`
               );
            }
            setTipoMensaje("success");
         } else {
            setMensaje(
               "¡Mensaje guardado! Hubo problemas enviando emails, pero revisaremos tu consulta."
            );
            setTipoMensaje("success");
         }

         // Clear form
         setForm({ nombre: "", email: "", consulta: "" });

         setTimeout(() => {
            setMensaje("");
            setTipoMensaje("");
         }, 8000);
      } catch (err) {
         console.error("Error in handleSubmit:", err);
         setMensaje(
            "Error al procesar el mensaje. Por favor, intenta nuevamente."
         );
         setTipoMensaje("error");
         setTimeout(() => {
            setMensaje("");
            setTipoMensaje("");
         }, 5000);
      }

      setEnviando(false);
   };

   return (
      <div className="min-h-screen bg-[#FAFAF8] px-6 py-16">
         <div className="max-w-5xl mx-auto grid md:grid-cols-[1fr_1.1fr] gap-14 items-start">
            <section>
               <p className="text-[0.68rem] uppercase tracking-[0.24em] text-[#9B6D3F] mb-4">Contacto</p>
               <h1
                  className="text-5xl md:text-6xl font-medium text-[#1A1A1A] leading-[1.04] mb-6"
                  style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
               >
                  Hablemos de
                  <br />
                  su próxima obra
               </h1>
               <div className="w-10 h-[1px] bg-[#9B6D3F] mb-7" />
               <p className="text-sm text-[#7A7570] leading-relaxed max-w-sm">
                  Si desea una escultura por encargo, una entrevista o simplemente realizar una consulta, este es el canal directo.
               </p>
            </section>

            <form onSubmit={handleSubmit} className="bg-white border border-[#EDE9E4] p-8 md:p-10">
               <div className="space-y-7">
                  <div>
                     <label className="block text-[0.68rem] uppercase tracking-[0.15em] text-[#7A7570] mb-2">
                        Nombre completo
                     </label>
                     <input
                        type="text"
                        name="nombre"
                        value={form.nombre}
                        onChange={handleChange}
                        className="w-full pb-2 bg-transparent border-b border-[#EDE9E4] focus:border-[#9B6D3F] outline-none text-sm text-[#1A1A1A] transition-colors placeholder-[#C5C0BB]"
                        required
                        disabled={enviando}
                        minLength={2}
                        maxLength={50}
                     />
                  </div>

                  <div>
                     <label className="block text-[0.68rem] uppercase tracking-[0.15em] text-[#7A7570] mb-2">
                        Email
                     </label>
                     <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        className="w-full pb-2 bg-transparent border-b border-[#EDE9E4] focus:border-[#9B6D3F] outline-none text-sm text-[#1A1A1A] transition-colors placeholder-[#C5C0BB]"
                        required
                        pattern="^[\w\.-]+@[\w\.-]+\.[a-zA-Z]{2,}$"
                        title="Ingrese un email válido"
                        disabled={enviando}
                     />
                  </div>

                  <div>
                     <label className="block text-[0.68rem] uppercase tracking-[0.15em] text-[#7A7570] mb-2">
                        Consulta
                     </label>
                     <textarea
                        name="consulta"
                        value={form.consulta}
                        onChange={handleChange}
                        className="w-full bg-[#FAFAF8] border border-[#EDE9E4] p-4 text-sm text-[#1A1A1A] focus:border-[#9B6D3F] outline-none resize-none transition-colors"
                        rows={6}
                        required
                        disabled={enviando}
                        minLength={10}
                        maxLength={500}
                        placeholder="Cuénteme su idea..."
                     />
                     <div className="text-[0.72rem] text-[#7A7570] mt-2 text-right">
                        {form.consulta.length}/500
                     </div>
                  </div>

                  <button
                     type="submit"
                     className="w-full bg-[#9B6D3F] text-white py-3.5 text-[0.72rem] uppercase tracking-[0.18em] hover:bg-[#6B4A2A] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                     disabled={enviando}
                  >
                     {enviando ? (
                        <>
                           <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                           Enviando...
                        </>
                     ) : (
                        "Enviar Mensaje"
                     )}
                  </button>

                  {mensaje && (
                     <div
                        className={`p-3 text-sm border-l-2 ${
                           tipoMensaje === "success"
                              ? "bg-emerald-50 text-emerald-700 border-emerald-500"
                              : "bg-red-50 text-red-700 border-red-500"
                        }`}
                     >
                        {mensaje}
                     </div>
                  )}
               </div>
            </form>
         </div>
      </div>
   );
}
